import React, { useEffect, useState } from "react";
import "./AccessForm.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { resetSinInSubscriber, sinInSubscriber } from "../../../store/subscribers/subscribersSlice";
import { resetCarrierSubscribe, carrierSubscribe } from "../../../store/subscribe/subscribeSlice";

import AForm from "../Components/AForm/AForm";
import SuccessMessage from "../Components/SuccessMessage/SuccessMessage";
import AFSignIn from "../Components/AFSignIn/AFSignIn";

const AccessForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { countryId } = useSelector((state) => state.settings);
  const { carrierSubscribeResult, carrierSubscribeError, carrierSubscribeLoading } = useSelector(
    (state) => state.subscribe
  );
  const { sinInSubscriberError, sinInSubscriberLoading, sinInSubscriberResult } = useSelector(
    (state) => state.subscribers
  );

  const [switcherValue, setSwitcherValue] = useState("fleetOwner");
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [selectedTrailerTypes, setSelectedTrailerTypes] = useState([]);
  const [country, setCountry] = useState(null);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [signEmail, setSignEmail] = useState();
  const [successMessage, setSuccessMessage] = useState(false);
  const [sign, setSign] = useState(true);

  const handleSubmitForm = () => {
    const data = {
      fleet_owner: switcherValue === "fleetOwner",
      trailer_types: selectedTrailerTypes || [],
      routes: selectedRoutes || [],

      registration_country_id: country?.value?.id,
      fullname: fullName,
      email: email,

      branch_id: countryId,
    };
    dispatch(carrierSubscribe(data));
  };
  const handleSubmitSignIn = () => {
    const data = {
      email: signEmail,
    };
    dispatch(sinInSubscriber(data));
  };
  useEffect(() => {
    if (sinInSubscriberResult) {
      dispatch(resetSinInSubscriber());
      setSuccessMessage(true);
    }
  }, [sinInSubscriberResult, dispatch]);

  useEffect(() => {
    if (carrierSubscribeResult) {
      dispatch(resetCarrierSubscribe());
      setSuccessMessage(true);
    }
  }, [carrierSubscribeResult, dispatch]);

  useEffect(() => {
    setEmail("");
    setSignEmail("");
  }, [sign]);

  useEffect(() => {
    setSuccessMessage(false);
    setSign(true);
  }, []);

  return (
    <div id='AccessForm'>
      <div className='wrapper'>
        {!successMessage && (
          <div className='AccessFormBox'>
            <div className='title'>
              <h2>{t("landing.accessLoadboard.Access to load board")}</h2>
              <p>{t("landing.accessLoadboard.Find the shipments")}</p>
            </div>
            <div className='SingButtons'>
              <div
                className={`SignupB SBAuth ${sign ? "active" : ""}`}
                onClick={() => setSign(true)}
              >
                <h3>{t("landing.accessLoadboard.Sign up")}</h3>
              </div>
              <div
                className={`SigninB  SBAuth ${!sign ? "active" : ""}`}
                onClick={() => setSign(false)}
              >
                <h3>{t("landing.accessLoadboard.Sign in")}</h3>
              </div>
            </div>
            {sign && (
              <AForm
                fullName={fullName}
                setFullName={setFullName}
                email={email}
                setEmail={setEmail}
                country={country}
                setCountry={setCountry}
                switcherValue={switcherValue}
                setSwitcherValue={setSwitcherValue}
                selectedRoutes={selectedRoutes}
                setSelectedRoutes={setSelectedRoutes}
                selectedTrailerTypes={selectedTrailerTypes}
                setSelectedTrailerTypes={setSelectedTrailerTypes}
                handleSubmit={handleSubmitForm}
                loading={carrierSubscribeLoading}
                error={carrierSubscribeError}
                text={t("landing.accessLoadboard.Sign Up & Haul More")}
              />
            )}
            {!sign && (
              <AFSignIn
                email={signEmail}
                setEmail={setSignEmail}
                loading={sinInSubscriberLoading}
                error={sinInSubscriberError}
                handleSubmit={handleSubmitSignIn}
              />
            )}
          </div>
        )}
        {successMessage && (
          <SuccessMessage
            title={t("landing.accessLoadboard.Thank You")}
            email={signEmail || email}
          />
        )}
      </div>
    </div>
  );
};

export default AccessForm;
